import { Button, Flex, Title } from '@mantine/core';
import {
  VacanciesTemplateHeader,
  VacanciesTemplatesBreadcrumbs,
  VacanciesTemplatesEdit,
  useVacanciesTemplatesConfirmDeleteModal,
} from '@features/vacanciesTemplates';
import { IconArchive } from '@tabler/icons-react';
import classes from './vacanciesTemplatesEdit.module.scss';
import { useBreadcrumbs } from '@shared/lib';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useGetVacancyTemplate } from '@entities/vacancy';
import { WithFallback } from '@shared/ui';

export const VacanciesTemplatesEditPage = () => {
  const { id } = useParams();
  const context = useBreadcrumbs();

  const { data: vacancyTemplate, isLoading } = useGetVacancyTemplate(
    Number(id)
  );

  useEffect(() => {
    if (!context || !vacancyTemplate?.name) {
      return;
    }

    context.setBreadcrumb(
      <VacanciesTemplatesBreadcrumbs subPage={vacancyTemplate.name} />
    );

    return () => {
      context.clearBreadcrumb();
    };
  }, [vacancyTemplate?.name]);

  const { openConfirmDeleteModal } = useVacanciesTemplatesConfirmDeleteModal();

  return (
    <Flex wrap='wrap' direction='column' gap={32} mx='auto' maw={1512} w='100%'>
      <WithFallback data={vacancyTemplate} isLoading={isLoading}>
        {data => (
          <>
            <VacanciesTemplateHeader
              isActive={data.isActive}
              id={data.id}
              createdAt={data.createdAt}
              updatedAt={data.updatedAt}
            />

            <Flex w='100%' align='center' justify='space-between' wrap='wrap'>
              <Title order={3} c='primary.7'>
                {data.name}
              </Title>

              <Button
                variant='subtle'
                size='sm'
                leftSection={<IconArchive size={20} />}
                className={classes.deleteButton}
                onClick={() => openConfirmDeleteModal(data.id, data.name)}
              >
                Удалить шаблон
              </Button>
            </Flex>

            <VacanciesTemplatesEdit />
          </>
        )}
      </WithFallback>
    </Flex>
  );
};
